import React, { Component } from 'react';

import api from '../../../api/';
// import Create from "./Create.js"
// import Edit from "./Edit.js"
// import Detail from "./Detail.js"
// import Delete from "./Delete.js"

import Modal from './Modal';
// import Distribuir from "./Distribuir.js"
import ImputarModal from "./ImputarModal/ImputarModal.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";
import NotificarLT from './NotificarLT'
import FinalizarOTT from './FinalizarOTT';

import dateFunctions from '../../functions/dateFunctions';


class Imputaciones extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "distribuir",
                    id: "distribuir",
                    accessor: "distribuir",
                    show: false,
                    private: true,
                },
                {
                    Header: "imputar",
                    id: "imputar",
                    accessor: "imputar",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.codigo.toUpperCase()),
                    show: true,
                },
                {
                    Header: "Titulo",
                    id: "titulo",
                    accessor: 'titulo',
                    show: true,
                },
                {
                    width:250,
                    Header: "Empresa/Organizacion",
                    id: "empr_org",
                    accessor: 'empr_org',
                    show: true,
                },
                {
                    Header: "Código Interno",
                    id: "codigo",
                    accessor: "codigo",
                    show: false,
                    private: true,
                },
                {
                    width: 75,
                    className: "text-center",
                    Header: "Número de Factura",
                    id: "nroFactura",
                    accessor: d => d.nroFactura,
                    show: true,
                },
                {
                    className: "text-center",
                    Header: "Fecha Facturación",
                    id: "fechaDeFacturacion",
                    accessor: d => dateFunctions.parseDate(d.fechaDeFacturacion),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />,
                },
                {
                    className: "text-center",
                    Header: "Fecha Cobro",
                    id: "fechaDeCobro",
                    accessor: d => dateFunctions.parseDate(d.fechaDeCobro),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />,
                },
                {
                    Header: "Monto ($)",
                    id: "monto",
                    className: "text-right",
                    accessor: d => dateFunctions.formatCurrency(d.monto),
                    show: true,
                },
                {
                    width: 90,
                    Header: "Informe",
                    id: "pk",
                    className: "text-center",
                    filterable: false,
                    sortable: false,
                    Cell: d => <a className='badge' href={`${api.imputaciones.reportes.reporteXLSX}${d.original.pk}`} target="_blank"><i className="fa fa-download" aria-hidden="true"></i> Descargar</a>,
                    show: true,
                },
                {
                    Header: "fechaEstado",
                    id: "fechaEstado",
                    accessor: "fechaEstado",
                    show: false,
                    private: true,
                },
                {
                    width: 125,
                    Header: "Estado",
                    id: "estado",
                    accessor: d => {
                        switch (d.estado) {
                            case "IMP-N":
                                return <div className={`badge badge-primary`}>
                                    {"Nueva"}<br></br>
                                    {d.fechaEstado && <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>}
                                </div>;
                            case "E-LTP":
                                return <div className={`badge badge-warning`}>
                                    {"Enviado a LTP"}<br></br>
                                    {d.fechaEstado && <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>}
                                </div>
                            case "E-OTT":
                                return <div className={`badge badge-success`}>
                                    {"Finalizada-OTT"}<br></br>
                                    {d.fechaEstado && <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>}
                                </div>
                        }

                    },
                    show: true,
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            className="w-100"
                            value={filter ? filter.value : "TODOS"}
                        >
                            <option value="">TODOS</option>
                            <option value="IMP-N">IMP-N</option>
                            <option value="E-LTP">E-LTP</option>
                            <option value="E-OTT">E-OTT</option>
                        </select>,
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'imputaciones_imputaciones_new',
                        component: (props) => <Modal {...props} action="CREATE" />,
                    },
                    {
                        edit: true,
                        permission: 'imputaciones_imputaciones_edit',
                        component: (props) => <Modal {...props} action="EDIT" />,
                    },
                    {
                        edit: true,
                        permission: 'imputaciones_imputaciones_detail',
                        component: (props) => <Modal {...props} action="DETAIL" />,
                    },
                    {
                        edit: true,
                        permission: 'imputaciones_imputaciones_delete',
                        component: (props) => <Modal {...props} action="DELETE" />,
                    },
                    {
                        edit: true,
                        permission: 'imputaciones_imputaciones_maillt',
                        component: NotificarLT,
                    },
                    {
                        edit: true,
                        permission: 'imputaciones_imputaciones_separar',
                        component: ImputarModal,
                    },
                    {
                        edit: true,
                        permission: 'imputaciones_imputaciones_enviar_ott',
                        component: FinalizarOTT,
                    },
                ]}
                apiUrl={api.imputaciones.imputaciones.list}
                columns={this.state.columns}
                exportUrl={api.imputaciones.imputaciones.export}
                title={"Imputaciones"}
                outerSort={[{ "id": "fechaDeFacturacion", "desc": true }]}
            />
        );
    }
}

export default Imputaciones;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/Imputaciones.js